<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['item.no']" :addon-before="$t('business.label.itemNo')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['item.name']" :addon-before="$t('business.label.itemName')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['location.no']" :addon-before="$t('business.label.locationNo')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['container.no']" :addon-before="$t('business.label.containerNo')" :loading="loading" allowClear @pressEnter="search" @search="search"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.no" title="business.label.lot"/>
      <vxe-column field="batch.no" title="business.label.batchNo"/>
      <vxe-column field="location.no" title="business.label.location"/>
      <vxe-column field="inventory.availableQuantity" title="business.label.availableQuantity"/>
      <vxe-column field="inventory.quantity" title="business.label.quantity"/>
      <vxe-column field="inventory.inventoryState" title="business.label.inventoryStatus">
        <span slot-scope="{ row }">{{inventoryStateData.find(item => item.ordinal === row.inventory.inventoryState).name}}</span>
      </vxe-column>
      <vxe-column field="inventory.availableOutboundQuantity" title="business.label.availableOutboundQuantity"/>
      <vxe-column field="inventory.lockedQuantity" title="business.label.lockedQuantity"/>
      <vxe-column field="log.reasons" title="business.label.lockReasons"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import { message } from 'ant-design-vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'InventoryUnLockingTable',
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': true
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77)// 表格竖向滚动条
    }
  },
  props: {
    inventoryStateData: {
      type: Array,
      default: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'location.no': '',
        'container.no': '',
        'locked': true
      }
      this.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('inventoryFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setCurrentRow(this.data[0])
            this.$refs.table.setRadioRow(this.data[0])
          }
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    unLocking() {
      let selectedRow = this.$refs.table.getCurrentRecord()
      if (selectedRow === null) {
        return this.$message.warning('请选中需要解锁的库存')
      }
      this.loading = true
      let args = {
        inventory: { id: selectedRow.inventory.id, availableOutboundQuantity: -selectedRow.inventory.lockedQuantity },
        reasons: null,
        'log.id': selectedRow.log.id,
        locking: false
      }
      post(Api.save, { type: 'inventoryLogPersister' }, args).then(res => {
        if (res.success) {
          message.success('解锁成功')
          this.getData()
          this.$emit('success')
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>